import React from 'react';
import ArchivingProfileStore from 'stores/ArchivingProfileStore';
import AuthStore from 'stores/AuthStore';
import FilterWordsProfileStore from 'stores/FilterWordsProfileStore';
import CardProfileStore from 'stores/CardProfileStore';
import DepartmentEditPage from './DepartmentEditPage';
import AltContainer from 'alt-container';
import CardProfileActions from 'actions/CardProfileActions';
import FilterWordsProfileActions from 'actions/FilterWordsProfileActions';
import TeamActions from 'actions/TeamActions';
import TeamListStore from 'stores/TeamListStore';
import DepartmentActions from 'actions/department/DepartmentActions';
import DepartmentFormActions from 'actions/DepartmentFormActions';
import DepartmentStore from 'stores/department/DepartmentStore';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import ArchivingProfileActions from 'actions/ArchivingProfileActions';

export default class DepartmentEditPageContainer extends React.Component {
  componentDidMount() {
    const {departmentId} = this.props.params;
    TeamActions.fetchTeamsForDepartment(departmentId);
    DepartmentActions.fetchDepartment(departmentId);
    ArchivingProfileActions.fetchArchivingProfiles();
    FilterWordsProfileActions.fetchAll();
    CardProfileActions.fetchAll();
  }
  render() {
    return (
      <AltContainer
        stores={{
          ArchivingProfileStore,
          AuthStore,
          CardProfileStore,
          DepartmentFormStore,
          DepartmentStore,
          FilterWordsProfileStore,
          TeamListStore,
        }}
        actions={{DepartmentActions, DepartmentFormActions}}>
        <DepartmentEditPage />
      </AltContainer>
    );
  }
}
